import { Register, store } from "@cleeng/mediastore-sdk";
import { Provider } from "react-redux";
import "@adyen/adyen-web/dist/adyen.css";
import { useRouter } from "next/router";

export default function RegisterPage() {

  const router = useRouter();

  const handleRegistrationSuccess = async () => {

    window.gtag?.('config', process.env.NEXT_PUBLIC_GA_CONFIG, {
      'user_id': localStorage.CLEENG_CUSTOMER_ID
    });
    window.gtag?.('event', 'registration', {
      method: 'Cleeng'
    });
    await router.push('/offers');
  };



  return (
    <div>
      <Provider store={store}>
        <Register onSuccess={() => handleRegistrationSuccess()}
          onHaveAccountClick={() => router.push('/')} />
      </Provider>
    </div>
  )
}